import { Shield, Sparkles, Hammer, Brush, Users, MessageSquare, ListChecks, BadgeCheck } from "lucide-react";

const ITEMS = [
  { icon: Shield, text: "Protección de zonas de paso" },
  { icon: Sparkles, text: "Orden y limpieza durante la obra" },
  { icon: Users, text: "Personal asegurado" },
  { icon: Hammer, text: "Herramientas y materiales adecuados" },
  { icon: Brush, text: "Remates cuidados" },
  { icon: MessageSquare, text: "Comunicación clara durante el trabajo" },
  { icon: ListChecks, text: "Presupuesto por partidas" },
  { icon: BadgeCheck, text: "Garantía en los trabajos realizados" },
];

export default function WhatNotSee() {
  return (
    <section className="bg-[#0A192F] text-white scroll-mt-20">
      <div className="container mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.2em] text-blue-300 font-semibold mb-3">Calidad invisible</div>
            <h2 className="font-display font-semibold text-3xl md:text-4xl tracking-tight leading-tight">
              Lo que no se ve <br className="hidden sm:block"/>también importa
            </h2>
            <p className="text-slate-300 mt-5 text-base leading-relaxed max-w-md">
              En una reforma no solo importa el resultado final. También importan la preparación, la protección, los materiales adecuados, la limpieza, la coordinación y los remates.
            </p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 gap-3">
            {ITEMS.map((it, i) => (
              <div
                key={i}
                data-testid={`hidden-quality-${i}`}
                className="flex items-start gap-3 p-4 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-colors"
              >
                <div className="w-9 h-9 rounded-lg bg-[#004B87] text-white grid place-items-center shrink-0">
                  <it.icon className="w-4 h-4" />
                </div>
                <div className="text-sm text-slate-200 font-medium leading-snug pt-1.5">{it.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
